<form *ngIf="showEntityDetail" [formGroup]="dynaEntityForm" autocomplete="off" novalidate=""
            style="margin-bottom: 10px;">
            <div class="form-group row">
                <div style="display:none">
                    <input class="form-control form-control-sm" formControlName="name">
                </div>
                <div style="display:none">
                    <input class="form-control form-control-sm" formControlName="ID">
                </div>
                <div class="col-sm-5">
                    <label>Display Name : </label>
                </div>
                <div class="col-sm-7">
                    <input class="form-control form-control-sm" formControlName="displayName">
                </div>

                <div class="col-sm-5 mt-2">
                    <label>Display Format : </label>
                </div>
                <div class="col-sm-7 mt-2">
                    <input class="form-control form-control-sm" formControlName="displayFormat">
                </div>
             
                <div class="col-sm-12">
                    <button type="button" class="btn btn-sm btn-secondary"
                        (click)="updateFormValues(dynaEntityForm.value,'update')">Update</button>
                </div>
            </div>
        </form>
<div class="row">
    <div class="col-md-6">
        <table  class="table  table-sm">
            <thead class="dragula-thead">
                <th>
                    Available
                </th>
            </thead>
            <tbody class="dragula-tbody" [dragula]='"entity-items"' id="AvailableEntities">
                <tr id="ai">
                    <td></td>
                </tr>
                <tr [id]="ae.InterfaceElementID" *ngFor="let ae of availableEntities">
                    <td>{{ae.DisplayProperties.DisplayName}}
                        <span style="visibility:hidden" id="{{entityCode}}{{ae.InterfaceElementID}}">
                            <button class="btn btn-sm btn-secondary"
                                (click)="editDynaEntityEditorItem(ae)">
                                <i id="button_DynaEdit" style="color:white"></i>
                            </button>
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="col-md-6">
            <table  class="table  table-sm">
                <thead class="dragula-thead">
                    <th>
                        Visible
                    </th>
                </thead>
                <tbody class="dragula-tbody" [dragula]='"entity-items"' id="VisibleEntities">
                    <tr id="vi">
                        <td></td>
                    </tr>
                    <tr [id]="ve.InterfaceElementID" *ngFor="let ve of visibleEntities">
                        <td>{{ve.DisplayProperties.DisplayName}} 
                            <span id="{{entityCode}}{{ve.InterfaceElementID}}">
                                <button class="btn btn-sm btn-secondary"
                                    (click)="editDynaEntityEditorItem(ve)">
                                    <i id="button_DynaEdit" style="color:white"></i>
                                </button>
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
    </div>
    
</div>
